module.exports = __webpack_public_path__ + "media/images/giftaway-logo-552ab41a966a57fb006c497c1f4e2fca.webp";